import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Time({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2.5 -2.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M34.3574 17.731c0 8.97996-7.354 16.26042-16.4253333 16.26042C8.86073333 33.99142 1.5074 26.71096 1.5074 17.731c0-8.98062 7.35333333-16.26108 16.4246667-16.26108C27.0034 1.46992 34.3574 8.75038 34.3574 17.731z" />
        <path d="M17.9322667 10.52446V17.731L25.7716 25.67608" />
      </g>
    </svg>
  )
}

Time.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
